import type { SavedPackagingSolution } from "@/schemas";

export const updateAllSolutionAttributeValuesToString = (solution: SavedPackagingSolution): SavedPackagingSolution => {
	return {
		...solution,
		attributes: ensureStringValues(solution.attributes),
		labels: solution.labels.map((l) => ({
			...l,
			attributes: ensureStringValues(l.attributes),
		})),
		cartons: solution.cartons.map((c) => ({
			...c,
			media: {
				...c.media,
				attributes: ensureStringValues(c.media.attributes),
			},
			labels: c.labels.map((l) => ({
				...l,
				attributes: ensureStringValues(l.attributes),
			})),
		})),
	};
};

const ensureStringValues = (attributes: Record<string, string>): Record<string, string> => {
	return Object.fromEntries(Object.entries(attributes).map(([key, value]) => [key, String(value)]));
};
